import { useState } from "react";
import DeferredLeadForm from "@/components/DeferredLeadForm";
import BookCallFlow from "@/components/BookCallFlow";

export default function FinalConversion() {
  const [bookCall, setBookCall] = useState({ open: false, prefill: null });
  return (
    <section
      id="final-cta"
      className="relative py-6 lg:py-8 bg-royal-deep text-white overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid-dark opacity-25" aria-hidden />
      <div
        className="absolute -left-32 top-10 h-[420px] w-[420px] rounded-full blur-3xl opacity-25"
        style={{ background: "var(--cyan)" }}
        aria-hidden
      />
      <div className="relative mx-auto max-w-[1440px] px-5 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <p className="font-mono-ui text-[11px] uppercase tracking-[0.22em] text-[var(--cyan)]">
            10 · Get course guidance
          </p>
          <h2 className="font-display text-2xl md:text-3xl lg:text-[38px] font-bold mt-4 leading-[1.05] text-balance">
            Not sure which course is right for you?
          </h2>
          <p className="mt-5 text-[16px] text-white/75 max-w-lg leading-relaxed">
            Tell us your goal. Our team will help you choose the right SAP, Workday, AI, or
            corporate training path.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <a
              href="#final-form"
              className="inline-flex items-center gap-2 rounded-md bg-[var(--cyan)] px-5 py-3 text-sm font-bold text-[var(--royal-deep)] hover:-translate-y-0.5 transition-transform"
            >
              Get Course Guidance
            </a>
            <a
              href="/corporate-training"
              className="inline-flex items-center gap-2 rounded-md border border-white/20 px-5 py-3 text-sm font-semibold hover:bg-white/5"
            >
              Request Corporate Training
            </a>
          </div>
        </div>

        <div id="final-form" className="lg:col-span-6">
          <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md p-6 lg:p-8">
            <DeferredLeadForm
              variant="contact"
              formName="home-page-enquiry-form-footer-section"
              surface="dark"
              minHeight={440}
              onSuccess={({ prefill }) => setBookCall({ open: true, prefill })}
            />
          </div>
        </div>
      </div>

      <BookCallFlow
        open={bookCall.open}
        prefill={bookCall.prefill}
        onClose={() => setBookCall({ open: false, prefill: null })}
      />
    </section>
  );
}
